<template>
  <div id="expensesPage">
    <new-expense-add
      ref="newExpenseAdd"
      @saveExpense="saveExpense"
      @updateExpense="updateExpense"
      :updateData="selected"
      @close="selected = {}"
    />
    <vs-popup
      class="holamundo"
      title="Kullanıcı Sil"
      :active.sync="deletePopupActive"
      v-esc="escape"
    >
      <vs-row vs-type="flex" vs-w="12">
        <p>Bu Gider Kaydını Silmek İstediğinize Eminmisiniz ?</p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button
          type="gradient"
          color="primary"
          @click="
            deletePopupActive = false;
            deletedId = null;
          "
          >Vazgeç</vs-button
        >
        <vs-button
          type="gradient"
          color="danger"
          icon-pack="feather"
          icon="icon-trash"
          @click="deleteData(deletedId)"
        >
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>
    <vs-table
      id="expenseDataList"
      ref="table"
      :data="expenses"
      :max-items="itemsPerPage"
      v-model="selected"
    >
      <div
        slot="header"
        class="w-full flex flex-wrap items-center flex-grow justify-between"
      >
        <vs-row vs-type="flex" vs-w="12" class="mb-1">
          <global-filter
            ref="filterer"
            :tableOptions="tableOptions"
            :filterOptions="filterOptions"
            :filterChips="filterChips"
            :filterOptionNames="filterOptionNames"
            :isActive="isFilterActive"
            @saveOptions="saveOptions"
            @close="isFilterActive = false"
          />
          <vs-row
            id="panelHeaderRow"
            v-show="!isFilterActive"
            vs-type="flex"
            vs-w="12"
            vs-justify="space-between"
          >
            <vs-col
              id="panel-actions"
              vs-type="flex"
              class="w-auto"
              vs-justify="center"
            >
              <vs-row vs-type="flex" vs-w="12">
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Gider Ekle" position="top">
                    <vs-button
                      @click="addNewExpense"
                      class="panel-action text-success xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-plus"
                    />
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Detaylı Filtereleme" position="top">
                    <vs-button
                      @click="isFilterActive = !isFilterActive"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="pickicon"
                      icon="icon-pick-filter"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Excel Export" position="top">
                    <vs-button
                      @click="getExcel"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-download"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="filter-chips" vs-type="flex">
              <vs-row
                vs-type="flex"
                vs-w="12"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  id="clearFilterButton"
                  v-if="filterChips.length > 0"
                  @click="clearFilter"
                  class="mr-2 bg-white text-danger panel-action-box-shadow"
                  icon-pack="feather"
                  icon="icon-slash"
                  radius
                  color="transparent"
                />
                <vs-col
                  vs-type="flex"
                  class="w-auto"
                  v-for="(chip, index) in filterChips"
                  :key="index"
                >
                  <vs-chip
                    color="white"
                    class="panel-action-box-shadow px-1"
                    @click="removeFilter(chip.col, index)"
                    v-show="chip.value != ''"
                    closable
                  >
                    <vs-row vs-tpye="flex" vs-w="12">
                      <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                        <span class="bold text-xsmaller text-dark">
                          {{ chip.name + " :" }}
                        </span>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        class="w-auto ml-1"
                        vs-align="center"
                      >
                        <span
                          class="weight-600 italic text-xsmaller text-primary"
                        >
                          {{ chip.value }}
                        </span>
                      </vs-col>
                    </vs-row>
                  </vs-chip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col
              id="table-page-size"
              vs-type="flex"
              class="w-auto"
              vs-justify="flex-end"
            >
              <vs-dropdown
                vs-trigger-click
                class="bg-white cursor-pointer panel-action-box-shadow"
              >
                <div
                  class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small"
                >
                  <span class="mr-2 page-size-dropdown-span"
                    >{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                    -
                    {{
                      totalDataRow - (currentPage + 1) * itemsPerPage > 0
                        ? (currentPage + 1) * itemsPerPage
                        : totalDataRow
                    }}
                    of
                    {{ totalDataRow }}</span
                  >
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="itemsPerPage = 10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 20">
                    <span>20</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-col>
          </vs-row>
        </vs-row>
      </div>

      <template slot="thead">
        <vs-th class="w-2/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'description' ? sortingHeadIcon : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('description')"
            >Açıklama
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'expenseDefinition.Name'
                ? sortingHeadIcon
                : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('expenseDefinition.Name')"
            >Tanım
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'created' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('created')"
            >Tarih
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            color="primary"
            type="flat"
            >Saat
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'user.Name' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('user.Name')"
            >Personel
          </vs-button>
        </vs-th>
        <vs-th class="w-1/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'paymentMethod.Name'
                ? sortingHeadIcon
                : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('paymentMethod.Name')"
            >Ödeme
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'price' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('price')"
            >Tutar
          </vs-button>
        </vs-th>
        <vs-th class="w-1/12">
          <vs-button
            color="primary"
            class="opacity-full p-1 weight-600"
            disabled="true"
            type="flat"
            >İşlem</vs-button
          >
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody style="text-align: center">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="w-2/12">
              <p class="text-center">{{ tr.description }}</p>
            </vs-td>

            <vs-td class="w-2/12">
              <p class="text-center">{{ tr.expenseDefinition.name }}</p>
            </vs-td>

            <vs-td class="w-1/12">
              <p class="text-center">{{ tr.created.substring(0,10) }}</p>
            </vs-td>
            <vs-td class="w-1/12">
              <p class="text-center">{{ tr.created.substring(11,16) }}</p>
            </vs-td>
            <vs-td class="w-2/12">
              <p class="text-center">{{ tr.user.name }}</p>
            </vs-td>

            <vs-td class="w-1/12">
              <p class="text-center">
                {{ tr.paymentMethod != null ? tr.paymentMethod.name : "" }}
              </p>
            </vs-td>

            <vs-td class="w-2/12">
              <p class="text-center">{{ $toCurrency(tr.price) }}</p>
            </vs-td>

            <vs-td class="w-1/12">
              <feather-icon
                v-if="tr.id != 1"
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                @click.stop="
                  deletedId = tr.id;
                  deletePopupActive = true;
                "
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <div class="d-flex w-full">
      <span class="ml-auto bold text-primary"
        >{{ $toCurrency(pageTotalAmount) }} TL</span
      >
      <span class="bold text-dark">/ {{ $toCurrency(totalAmount) }} TL</span>
    </div>
    <pagination-default
      :setCurrentPage="tableOptions.pageIndex"
      :totalLenght="calculatePageLength"
      @currentPage="getCurrentPage"
    ></pagination-default>
  </div>
</template>

<script>
import GlobalFilter from "../GlobalFilter";
import moduleExpense from "@/store/expense/moduleExpense.js";
import PaginationDefault from "../PaginationDefault";
import NewExpenseAdd from "./NewExpenseAdd.vue";
import { deleteExpense, getExcel } from "@/api/Expense.js";
export default {
  components: {
    PaginationDefault,
    GlobalFilter,
    NewExpenseAdd,
  },
  data() {
    return {
      deletedId: null,
      deletePopupActive: false,
      tableOptions: {},
      sortingHeadIcon: "",
      sortingHeadIconBool: 1,
      currentPage: 0,
      itemsPerPage: 10,
      selected: {},

      isFilterActive: false,
      filterOptions: [
        "dateRange",
        "timeRange",
        "branch",
        "expenseDescription",
        "expenseDefinition",
        "personal",
        "paymentMethod",
        "price",
      ],
      filterOptionNames: [
        "Tarih",
        "Saat",
        "Şube",
        "Açıklama",
        "Tanım",
        "Personel",
        "Ödeme",
        "Tutar",
      ],
      filterChips: [],
    };
  },
  computed: {
    expenses() {
      return this.$store.state.expense.expenses;
    },
    totalDataRow() {
      return this.$store.state.expense.totalDataRow;
    },
    totalAmount() {
      return this.$store.state.expense.totalAmount;
    },
    pageTotalAmount() {
      return this.$store.state.expense.pageTotalAmount;
    },
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return mod > 0
        ? (this.totalDataRow - mod) / this.itemsPerPage + 1
        : this.totalDataRow / this.itemsPerPage;
    },
  },
  methods: {
    getExcel() {
      getExcel(this.tableOptions)
        .then((res) => {
          if (res && res.status == 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            let now = this.$now.date();
            link.setAttribute(
              "download",
              "Gider Listesi" +
                now.getDate() +
                " " +
                this.$months()[now.getMonth()].name +
                " " +
                now.getFullYear() +
                ".xlsx"
            );
            document.body.appendChild(link);
            link.click();

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    updateExpense(payload) {
      this.$store
        .dispatch("expense/updateExpense", payload)
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Gider Kaydı Güncellendi!",
          });
        })
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Gider Güncellenemedi !",
            text: error,
          });
        });
    },
    escape() {
      if (this.deletePopupActive) {
        this.deletePopupActive = false;
        this.deletedId = null;
      }
    },
    deleteData(id) {
      deleteExpense(id).then((res) => {
        if (res && res.status == 200) {
          this.$store.dispatch("expense/removeExpense", id).then((data) => {
            this.deletePopupActive = false;
            this.$vs.notify({
              color: "success",
              title: "Silme İşlemi",
              text: "Gider Başarıyla Silindi",
            });
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Silme İşlemi Başarısız !",
          });
        }
      });
    },
    saveExpense(payload) {
      this.$store.dispatch("expense/addExpense", payload).catch((error) => {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: error,
        });
      });
    },
    addNewExpense() {
      this.$refs.newExpenseAdd.isActive = true;
    },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "Created",
        sortDirection: "desc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        dateRange: {
          startDate: this.$now.date(),
          endDate: this.$now.date(),
        },
        timeRange: {
          startTime: null,
          endTime: null,
        },
        price: {
          min: null,
          max: null,
        },
        branch: this.$currentUser.branch,
        personal: null,
        paymentMethod: null,
        expenseDescription: null,
        expenseDefinition: null,
      };
      if (!this.$isCenterBranch() && !this.$isRegionalCenterBranch()) {
        let branchPropIndex = this.filterOptions.indexOf("branch");
        this.filterOptions.splice(branchPropIndex, 1);
        this.filterOptionNames.splice(branchPropIndex, 1);
        delete this.tableOptions["branch"];
      }
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
      val == false ? (this.selected = "") : null;
    },
    getExpenseList() {
      if (this.$isRegionalCenterBranch()) {
        this.$store
        .dispatch("expense/fetchDataListItemsExpenseForDealer", this.tableOptions)
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: error,
          });
        });
      } else {
        this.$store
        .dispatch("expense/fetchDataListItemsExpense", this.tableOptions)
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: error,
          });
        });
      }
      
    },
    setSortingOptions(val) {
      if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
      this.tableOptions.sortBy = val;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.tableOptions.sortBy = "";
      }
    },
  },
  created() {
    if (!moduleExpense.isRegistered) {
      this.$store.registerModule("expense", moduleExpense);
      moduleExpense.isRegistered = true;
    }
    this.tableOptions = {
      sortBy: "Created",
      sortDirection: "desc",
      pageIndex: 0,
      pageSize: this.itemsPerPage,
      dateRange: {
        startDate: this.$now.date(),
        endDate: this.$now.date(),
      },
      timeRange: {
        startTime: null,
        endTime: null,
      },
      price: {
        min: null,
        max: null,
      },
      branch: this.$currentUser.branch,
      personal: null,
      paymentMethod: null,
      expenseDescription: null,
      expenseDefinition: null,
    };
    this.filterChips.length = 0;
    if (!this.$isCenterBranch()&&!this.$isRegionalCenterBranch()) {
      let branchPropIndex = this.filterOptions.indexOf("branch");
      this.filterOptions.splice(branchPropIndex, 1);
      this.filterOptionNames.splice(branchPropIndex, 1);
      delete this.tableOptions["branch"];
    }
  },
  watch: {
    tableOptions: {
      deep: true,
      handler(val) {
        this.$nextTick(() => {
          this.getExpenseList();
        });
      },
    },
    selected(val) {
      if (Object.entries(val).length > 0) this.addNewExpense();
    },
    currentPage: function (val) {
      this.tableOptions.pageIndex = val;
    },
    sortingHeadIconBool: function () {
      switch (this.sortingHeadIconBool) {
        case 1:
          this.tableOptions.sortDirection = "";
          break;
        case 2:
          this.tableOptions.sortDirection = "asc";
          break;
        case 3:
          this.tableOptions.sortDirection = "desc";
          break;
      }
      this.currentPage = 0;
      this.tableOptions.pageIndex = this.currentPage;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
      this.tableOptions.pageIndex = this.currentPage;
    },
  },
};
</script>

<style>
#expenseDataList .con-tablex {
  max-height: calc(100vh - 230px);
  overflow-y: auto;
}
</style>
